import React from 'react';

import { Grid, Switch, Typography } from '@mui/material';
import { UserPermissions } from 'src/types/users';

type PermissionAction = 'read' | 'create' | 'update' | 'delete' | 'style' | 'invoicesHistory';

export interface AdmPermissionsRowProps {
  title: string;
  isChildren: boolean;
  userPermissions: UserPermissions;
  auth: string;
  onChangePermissions: (c: boolean, v: string, a: string) => void;
  hasSelects?: boolean;
  actionColumns?: Array<PermissionAction | null>;
  indentLevel?: number;
}

const DEFAULT_ACTION_COLUMNS: PermissionAction[] = ['read', 'create', 'update', 'delete'];

export default function AdmPermissionsRow({
  title,
  isChildren,
  userPermissions,
  auth,
  onChangePermissions,
  hasSelects,
  actionColumns = DEFAULT_ACTION_COLUMNS,
  indentLevel = 1,
}: AdmPermissionsRowProps) {
  const permission = userPermissions[auth as keyof UserPermissions] as
    (UserPermissions[keyof UserPermissions] & Record<string, boolean | undefined>) | undefined;

  return (
    <Grid container>
      <Grid item xs={4}>
        <Typography
          variant={isChildren ? 'body2' : 'body1'}
          ml={isChildren ? 5 * indentLevel : 0}
          my={1}
          display={isChildren ? 'list-item' : 'flex'}
        >
          {title}
        </Typography>
      </Grid>

      {hasSelects && (
        <>
          {actionColumns.map((action, index) => (
            <Grid
              key={`${auth}-${title}-${action || `empty-${index}`}`}
              item
              xs={2}
              display="flex"
              justifyContent="center"
            >
              {action && (
                <Switch
                  checked={Boolean(permission?.[action])}
                  onChange={(e) => onChangePermissions(e.target.checked, action, auth)}
                />
              )}
            </Grid>
          ))}
        </>
      )}
    </Grid>
  );
}
